import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { LINKS, openExternalLink } from '../../config/links';
import { colors, shared } from '../../styles/theme';
import PlatformIcon from '../PlatformIcon';
import ArrowIcon from '../ArrowIcon';

const stores = [
  ['android', 'Google Play', LINKS.playStore],
  ['huawei', 'Huawei AppGallery', LINKS.appGallery],
  ['ios', 'Apple App Store', LINKS.appStore],
];

function AccessSection() {
  return (
    <section className={css(styles.outer)}>
      <div className={css(styles.inner)}>
        <div className={css(styles.web)}>
          <div>
            <p className={css(styles.eyebrow)}>Get YaBatho</p>
            <h2 className={css(styles.title)}>Order online now</h2>
            <p className={css(styles.text)}>
              Enjoy your favourite local meals from any browser in just a few clicks.
            </p>
          </div>
          <button
            className={css(styles.webButton)}
            onClick={() => openExternalLink(LINKS.customerWebApp)}
          >
            <PlatformIcon platform="web" inverse />
            <span>Open Customer Web App</span>
            <ArrowIcon />
          </button>
        </div>

        <div className={css(styles.mobile)}>
          <p className={css(styles.mobileTitle)}>Download the mobile app</p>
          <div className={css(styles.storeGrid)}>
            {stores.map(([platform, label, url]) => (
              <button className={css(styles.storeButton)} key={label} onClick={() => openExternalLink(url)}>
                <PlatformIcon platform={platform} />
                <span>{label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  outer: {
    padding: '0 24px 70px',
    '@media (max-width: 520px)': { padding: '0 16px 48px' },
  },
  inner: {
    ...shared.container,
    maxWidth: '1240px',
    paddingTop: '38px',
    paddingBottom: '38px',
    display: 'grid',
    gridTemplateColumns: '0.9fr 1.1fr',
    gap: '38px',
    border: `1px solid ${colors.gold}`,
    borderRadius: '8px',
    backgroundColor: colors.ink,
    color: colors.white,
    boxShadow: '0 28px 60px rgba(15, 61, 46, 0.18)',
    '@media (max-width: 900px)': { gridTemplateColumns: '1fr' },
    '@media (max-width: 520px)': {
      padding: '32px 20px',
    },
  },
  web: { display: 'grid', gap: '22px' },
  eyebrow: {
    ...shared.eyebrow,
    marginBottom: '7px',
  },
  title: {
    margin: '0 0 8px',
    color: colors.white,
    fontSize: 'clamp(1.9rem, 4vw, 3rem)',
    lineHeight: 1.05,
    '@media (max-width: 520px)': {
      fontSize: '1.65rem',
    },
  },
  text: {
    maxWidth: '500px',
    margin: 0,
    color: colors.goldSoft,
    lineHeight: 1.6,
  },
  webButton: {
    ...shared.primaryButton,
    minHeight: '64px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gap: '12px',
    alignItems: 'center',
    textAlign: 'center',
    border: `1px solid ${colors.gold}`,
    '@media (max-width: 680px)': {
      minHeight: '54px',
      padding: '7px 12px',
      gap: '9px',
      fontSize: '0.9rem',
      whiteSpace: 'nowrap',
    },
  },
  mobile: {
    paddingLeft: '38px',
    borderLeft: '1px solid rgba(230, 216, 190, 0.34)',
    '@media (max-width: 900px)': {
      paddingTop: '28px',
      paddingLeft: 0,
      borderTop: '1px solid rgba(230, 216, 190, 0.34)',
      borderLeft: 0,
    },
  },
  mobileTitle: {
    margin: '0 0 14px',
    color: colors.white,
    fontWeight: '900',
  },
  storeGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '10px',
    '@media (max-width: 680px)': {
      gridTemplateColumns: '1fr',
      gap: '8px',
      paddingBottom: '18px',
    },
  },
  storeButton: {
    minHeight: '64px',
    width: '100%',
    padding: '10px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '10px',
    border: '1px solid rgba(230, 216, 190, 0.7)',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    color: colors.white,
    fontWeight: '900',
    cursor: 'pointer',
    boxSizing: 'border-box',
    '@media (max-width: 680px)': {
      minHeight: '48px',
      padding: '4px 10px',
      display: 'grid',
      gridTemplateColumns: '38px 1fr 38px',
      gap: '8px',
      fontSize: '0.84rem',
      textAlign: 'center',
    },
  },
});

export default AccessSection;
